/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { AgentSetupState, ConversationsIssuesCluster } from "./data-contracts";

/**
 * No description
 * @tags agents
 * @name GetConversationsIssuesCluster
 * @summary Get a conversations issues cluster by its identifier
 * @request GET:/orgs/{organizationId}/conversations-clusters/{clusterId}
 * @secure
 */

// @ts-ignore
export const getConversationsIssuesCluster: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the cluster */
    clusterId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: ConversationsIssuesCluster;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/conversations-clusters/{clusterId}",
  method: "get",
  streaming: false,
  tags: ["agents"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Get the state of the agent.
 * @tags agents, critical
 * @name GetAgentSetupState
 * @summary Get the agents setup state
 * @request GET:/orgs/{organizationId}/agents-setup
 * @secure
 */

// @ts-ignore
export const getAgentSetupState: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: AgentSetupState;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/agents-setup",
  method: "get",
  streaming: false,
  tags: ["agents", "critical"],
  criticalityLevel: "high",
  deprecated: false,
};
